export const categoryArray = ["SC","ST","OBC","NT","VJ","SBC","Open","Others"]